







// vendor
import { defineComponent } from "@vue/composition-api";
// project
import { ExploreStudySessions } from "@/components.studies/explore-study-sessions";

export default defineComponent({
	props: {
		studyId: {
			type: String,
			required: true,
		},
	},
	components: {
		ExploreStudySessions,
	},
	setup() {
		return {
		};
	},
});
